const data = {
    cards: [
        {
            id: 0,
            count: `01`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1698950488/PortfolioAsset/Screenshot_from_2023-11-02_19-38-05.png`,
            title: `Contoso Dashboard - DevUp Solutions`,
            content: `Made with React, Tailwindcss, Typescript. The demo shows a simplified version of the app.`,
            demoLink: `https://nextjs13-workapp-mini-clone.vercel.app/`,
            repoLink: `https://nextjs13-workapp-mini-clone-git-master-blenderwang.vercel.app/`,
        },
        {
            id: 1,
            count: `02`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1657880714/PortfolioAsset/Screenshot_3.jpg`,
            title: `Search with GitHub API`,
            content: `Made with NextJs, Bulma CSS, Typescript and GitHub API. Deployed on Vercel.`,
            demoLink: `https://nextjs-gihub-api.vercel.app/`,
            repoLink: `https://github.com/BlenderWang/nextjs-gihub-api`,
        },
        {
            id: 2,
            count: `03`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1650875971/PortfolioAsset/gallery.jpg`,
            title: `Gallery`,
            content: `From development to deployment, with NextJs, Strapi and Docker. Fully embrace every technoloy!`,
            demoLink: `https://image-gallery-b3n4vn6cs-blenderwang.vercel.app/`,
            repoLink: `https://github.com/BlenderWang/image-blog`,
        },
        {
            id: 3,
            count: `04`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1648979815/PortfolioAsset/payout1.jpg`,
            title: `Gigapay`,
            content: `It has never been easier to make payout and receiving salary. Please visit gigapay.co to learn more.`,
            demoLink: ``,
            repoLink: ``,
        },
        {
            id: 4,
            count: `05`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1617961167/PortfolioAsset/Screenshot_from_2021-04-09_11-37-01.jpg`,
            title: `EShop -- MERN e-commerce project`,
            content: `An e-commerce project taking advantage of the MERN stack and fully incorporate Redux with React.`,
            demoLink: `https://eshop-ecommerce-app.herokuapp.com/`,
            repoLink: `https://github.com/BlenderWang/eshop-ecommerce-app`,
        },
        {
            id: 5,
            count: `06`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1648989687/PortfolioAsset/Home_desktop.png`,
            title: `Nordic News Center Project`,
            content: `Server-side rendered news website. Strapi cms headless main content hub.`,
            demoLink: ``,
            repoLink: `https://github.com/BlenderWang/nordic_news_center_nextjs_strapi`,
        },
        {
            id: 6,
            count: `07`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1648988293/PortfolioAsset/Screenshot_20200810_222718.png`,
            title: `coding test for Skilldar`,
            content: `Skilldar provides a platform to connect talents such with companies who are in search for the right people.`,
            demoLink: ``,
            repoLink: `https://github.com/BlenderWang/challenge-solution`,
        },
        {
            id: 7,
            count: `08`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1578820858/Flax.png`,
            title: `template site with Strapi and Gatsby`,
            content: `During the first internship, I worked on re-creating the company's website from mockup to final deployment. It has been a super fun and educational process. `,
            demoLink: `https://strapi-gatsby-postgresql-temp.netlify.com/`,
            repoLink: `https://github.com/BlenderWang/strapi-gatsby-site`,
        },
        {
            id: 8,
            count: `09`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1569525067/PortfolioAsset/school-project-01.jpg`,
            title: `the white stripes tribute page with Jekyll`,
            content: `This was my most successful school group project. And I got to do plenty of animation with CSS and AnimeJS.`,
            demoLink: `https://github.com/Bikelund/White-Stripes`,
            repoLink: `https://angry-heisenberg-302cd5.netlify.com/`,
        },
        {
            id: 9,
            count: `10`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1569525067/PortfolioAsset/carlos-website-template.jpg`,
            title: `an html, css and javascript freelance project`,
            content: `It was a freelance job I had done for a friend's friend. There was a little bit implementation of parallax effect and pulling images from source.unsplash.com.`,
            demoLink: `https://reverent-swirles-2fac9c.netlify.com/`,
            repoLink: `https://github.com/BlenderWang/simpleWebsite`,
        },
        {
            id: 10,
            count: `11`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1569525066/PortfolioAsset/mini-search.jpg`,
            title: `mini tv/film search demo`,
            content: `A very much simplified IMDB inspired side project using TVMaze API. I learned pretty much on the spot how it worked with Promise. Cool stuff!`,
            demoLink: `https://github.com/BlenderWang/tv-search`,
            repoLink: `https://blenderwang.github.io/tv-search/`,
        },
        {
            id: 11,
            count: `12`,
            src: `https://res.cloudinary.com/shirlzzz9/image/upload/v1569525066/PortfolioAsset/school-project-02.jpg`,
            title: `flexbox vs css grid`,
            content: `My favorite school project done by only HTML and CSS in such psychodelic color scheme. Needless to say without SCSS it took me quite a while to build it up. It made me love CSS even more!`,
            demoLink: `https://codepen.io/blenderWang/pen/ebvqVz?editors=1100`,
            repoLink: `https://codepen.io/blenderWang/pen/ebvqVz?editors=1100`,
        },
    ],
};

export default data;
